<template>
  <div class="gbwaps-page">
    <main>
      <section class="page-hero">
        <div class="content-narrow">
          <Breadcrumb :items="breadcrumb" />
          <h1>{{ title }}</h1>
          <p v-if="intro" class="page-intro">{{ intro }}</p>
        </div>
      </section>
      <section class="page-content">
        <div class="content-narrow">
          <slot />
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Breadcrumb from '@/components/gbwaps/Breadcrumb.vue';
import { initGbwapsPageUI } from '@/utils/gbwaps-ui';

export default {
  name: 'GbwapsLayout',
  components: { Breadcrumb },
  props: {
    title: {
      type: String,
      required: true,
    },
    intro: {
      type: String,
      default: '',
    },
    breadcrumb: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.$nextTick(() => initGbwapsPageUI(this.$el));
  },
  updated() {
    this.$nextTick(() => initGbwapsPageUI(this.$el));
  },
};
</script>
